const types = {
  GOOGLE: 'GOOGLE',
  PHYSICAL: 'PHYSICAL',
  OTHER: 'OTHER'
};

export default types;